import React from 'react';

// The list of input fields (by accessionKey) that are handled by this component
const validProfileSpecificFieldAccessionKeys = [
	'Collection Time #1',
	'Collection Time #2',
	'Collection Time #3',
	'Collection Time #4',
	'Collection Time #5',
	'Sample 1',
	'Sample 2',
	'Sample 3',
	'Sample 4',
	'Sample 5',
	'Sample 6',
	'Sample 7',
	'Sample 8',
];

export default function CollectionTimeFields({ form, onChange }) {
	const formFields = validProfileSpecificFieldAccessionKeys.map(key => form?.[key]).filter(Boolean);
	
	if (!formFields.length) {
		return null;
	}

	return (
		<div id="collectionTimeFields" className="col-md-12 form-group">
			<table>
				<tbody>
					{formFields.map((item) => {
						if (!item) {
							return null;
						}
						const key = item.accessionKey;
						const description = key;

						return (
							<tr key={key}>
								<td className="pe-2">
									<strong>
										{description}
										<span className="text-danger">*</span>
									</strong>
								</td>
								<td>
									<input
										type="time"
										name="sample-time"
										pattern="[0-9]{2}:[0-9]{2}[A-Z]{2}"
										value={item.value}
										data-accessionkey={key}
										onChange={onChange}
									/>
									{item.valid === false && (
										<span className="validation-message text-danger ps-2">
											Please fill out this field.
										</span>
									)}
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
}